<app-menu-common url="sales"></app-menu-common>

<div class="pagecontent">
  <div class="pagetitle grey" >RSPs non rapprochés</div>
  <div class="table-container">
    @if (rsps.length > 0) {
      <table>
        <thead>
          <tr>
            <!-- <th>ID</th> -->
            <th>Num. Facture</th>
            <th>Date Comptable</th>
            <th>Bénéficiaire</th>
            <th>NIR</th>
            <th>Org. AMO</th>
            <th>Attendu</th>
            <th>Payé</th>
            <th>État</th>
            <th>Org. AMC</th>
            <th>Attendu</th>
            <th>Payé</th>
            <th>État</th>
            <th>État global</th>
          </tr>
        </thead>
        <tbody>
          @for (rsp of rsps; track rsp; let even = $even) {
            <tr (click)="toggleRsp(rsp)" [class.selected]="selectedRsp === rsp" [class.even-row-group]="even">
              <!-- <td>{{ rsp.id }}</td> -->
              <td>{{ rsp.numFacture }}</td>
              <td>{{ rsp.dateComptable | date:'dd/MM/yyyy' }}</td>
              <td>{{ rsp.data.nomBenef }} {{ rsp.data.prenomBenef }}</td>
              <td>{{ rsp.data.numSecu }}</td>
              <td class="col-group-left">{{ rsp.typeEmetFic }} - {{ rsp.numEmetFic }}</td>
              <td class="text-right font-mono bold">{{ ($safeNavigationMigration(rsp.data.partAMO?.montantDemande) | fcfse) || '' }}</td>
              <td class="text-right font-mono bold">{{ ($safeNavigationMigration(rsp.data.partAMO?.montantPaiement) | fcfse) || '' }}</td>
              <td class="col-group-right">{{ stateHelper.getEtatRsp(rsp.data, true).label }}</td>
              <td>{{ rsp.data?.partAMC?.numDestAMC || '' }}</td>
              <td class="text-right font-mono bold">{{ ($safeNavigationMigration(rsp.data.partAMC?.montantDemande) | fcfse) || '' }}</td>
              <td class="text-right font-mono bold">{{ ($safeNavigationMigration(rsp.data.partAMC?.montantPaiement) | fcfse) || '' }}</td>
              <td class="col-group-right">{{ stateHelper.getEtatRsp(rsp.data, false).label }}</td>
              <td>{{ rsp.etat }}</td>
            </tr>
            @if (false) {
              <tr [class.even-row-group]="even">
                <td></td>
                <td colspan="3">
                  <div>{{ rsp.data.libVirement1 }}</div>
                  <div class="sub-line">{{ rsp.data.libVirement2 }}</div>
                </td>
                <td colspan="9"></td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
  </div>

  @if (selectedRsp) {
    <div class="side-panel-backdrop" (click)="closePanel()"></div>
  }

  <div class="side-panel" [class.open]="selectedRsp">
    @if (selectedRsp) {
      <div class="side-panel-content">
        <button class="close-btn" (click)="closePanel()">&times;</button>
        <div class="rsp-detail-wrapper">
          <div class="rsp-header">
            <div>Détail du RSP</div>
            <div class="grey" style="font-size: .7em; margin-right: 10px;;">#{{ selectedRsp.id }}</div>
          </div>
          <div class="flexcolumn">
            <app-detail-rsp [rsp]="selectedRsp" [isRecon]="true"></app-detail-rsp>
          </div>
        </div>
      </div>
    }
  </div>

  @if (rsps.length === 0) {
    <div>
      <p>Aucun RSP à rapprocher</p>
    </div>
  }
</div>